/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import { PmcMessageType } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

export interface VideoAssetCacheInterface {
    /**
     * Commence asset cache if not already started.
     *
     * Note: Does not wait for download to finish.
     *
     * @returns `true` if asset is already cached, else `false`.
     */
    cacheVideoAsset(assetUuid: string): Promise<boolean>;

    /**
     * Returns path to a video whether cached or not.
     *
     * If not cached, the URL to the server will be returned.
     */
    getVideoPath(assetUuid: string): Promise<string>;

    /**
     * Check if an asset is already cached.
     *
     * @returns `true` if asset is already cached, else `false`.
     */
    isCachedAsset(assetUuid: string): Promise<boolean>;
}

export function supportsVideoAssetCache(platform: unknown): platform is VideoAssetCacheInterface {
    if (platform instanceof PlayerPmc) {
        return (
            platform.supportsMessage(PmcMessageType.AssetDownload) &&
            platform.supportsMessage(PmcMessageType.AssetStatus)
        );
    }
    return (
        platform instanceof Object &&
        'cacheVideoAsset' in platform &&
        'getVideoPath' in platform &&
        'isCachedAsset' in platform
    );
}
